import { Box, Stack, Typography } from "@mui/material";
import { singleLineEllipsis } from "./CardHeader";

export default function InfoBox({ title, lines }: { title: string; lines: string[] }) {
  return (
    <Box sx={{ background: "#f9fafb", borderRadius: 2, p: 1.5 }}>
     <Typography
                     variant="subtitle2"
                     fontWeight={600}
                     gutterBottom
                     sx={singleLineEllipsis}
                   >
        {title}
      </Typography>
      <Stack spacing={0.5}>
        {lines.map((line, i) => (
          <Typography
            key={i}
            variant="caption"
            color="text.secondary"
            sx={{ whiteSpace: "normal" }}
          >
            {line}
          </Typography>
        ))}
      </Stack>
    </Box>
  );
}